import React from 'react';
import PropTypes from 'prop-types';
import HMSSlide from 'components/HMSSlide';
import css from './HMSBlock.module.scss';
import cn from 'classnames';

class HMSBlock extends React.Component {
    static propTypes = {
        slides: PropTypes.array
    }

    state = {
        active: 0
    }

    _handleIndicatorClick = e => {
        e.preventDefault();
        const index = parseInt(e.currentTarget.dataset.index),
            forward = index > this.state.active;

        if (this.state.active === index) return;

        this.setState({ active: index, forward: forward });
    }

    _handleNavigationClick = e => {
        e.preventDefault();
        const { direction } = e.currentTarget.dataset;

        if (direction === "next") {
            if (this.props.slides.length <= this.state.active + 1) return;
            this.setState({ active: this.state.active + 1, forward: true });
        }
        else if (direction === "prev") {
            if ((this.state.active - 1) < 0) return;
            this.setState({ active: this.state.active - 1, forward: false });
        }
    }

    render() {

        const {
            slides
        } = this.props;

        const {
            active,
            forward
        } = this.state;

        if(!slides) return null;

        return (

            <div className={css.block}>
                <div className={css["slides-wrapper"]}>
                    <ul className={css.slides} style={{ transform: 'translateX(-' + (active * 100) + '%)' }}>
                        {slides.map((slide, index) => (
                            <HMSSlide key={index} {...slide} />
                        ))}
                    </ul>
                </div>
                {slides.length > 1 && (
                    <div>
                        <div className={css.nav} key="nav">
                            {!active == 0 && (
                                <button
                                    type="button"
                                    data-direction="prev"
                                    onClick={this._handleNavigationClick}
                                    className={css["nav-prev"]}
                                >
                                    <span>Previous</span>
                                </button>
                            )
                            }
                            {!(active == (slides.length - 1)) && (
                                <button
                                    type="button"
                                    data-direction="next"
                                    onClick={this._handleNavigationClick}
                                    className={css["nav-next"]}
                                >
                                    <span>Next</span>
                                </button>
                            )
                            }
                        </div>
                        <ul className={css["nav-indicators"]} key="indicators">
                            {slides.map((slide, index) => (
                                <li key={index}>
                                    <button
                                        data-index={index}
                                        type="button"
                                        onClick={this._handleIndicatorClick}
                                        className={cn({
                                            [css.active]: active === index,
                                            [css["direction-forward"]]: forward
                                        })}
                                    >
                                        <span>{index+1}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default HMSBlock;




// WEBPACK FOOTER //
// ./src/components/HMSBlock/HMSBlock.jsx